export enum RegisterType {
    ACCOUNT = "ACCOUNT",
    ORG = "ORG"
}